import { useSettings } from '@capsicum/common';
import { useAvailableMarketsPerPartnerTrending, useMainCurrenciesQuery } from '@capsicum/socios-core';

export const useTrendingFanTokens = () => {
	const { settings } = useSettings();
	const { isMarketplaceEnabled } = settings;

	const { data: availableMarketsData, isLoading } = useAvailableMarketsPerPartnerTrending();

	const { data: currencies } = useMainCurrenciesQuery();
	const { defaultCurrency } = currencies ?? {};

	return {
		availableMarketsData,
		defaultCurrency,
		isLoading,
		isMarketplaceEnabled
	};
};
